import { Record } from 'immutable'

export class GoodsType extends Record({
    id: undefined,
    name: undefined,
}) {}
